// @flow
import * as cookieMonster from 'cookie';
import type { Cookie } from './types';

export function getCookieValue(cookie: Cookie, cookieKey: string): ?string {
    const parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return (parsed && parsed[cookieKey]) || null;
}
